export default "__VITE_ASSET__DdgjGmC$__"